/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { ProviderInterface, UserRolesEnum } from "@malmur-technologies/medicalsystem-shared";
import { getNewDoctorDataContent } from "utils/model.utils";
import NewStepperForm from "../StepperForm";
import { RoutesConstants } from "@malmur-technologies/medicalsystem-shared";
import { NewDoctorStepperFormProps } from "interfaces";

/**
 * Dynamic stepper form wrapper for creating new doctors or nurses.
 * Initializes a new provider model and configures the stepper form based on provider type.
 * 
 * Features:
 * - Creates new doctor data model with defaults
 * - Determines provider type: Doctor, Head Nurse, or Nurse
 * - Sets appropriate redirect path based on type
 * - Configures multi-step form with NewStepperForm
 * 
 * Provider Types:
 * - Doctor: isDoctor=true → redirects to /doctors
 * - Head Nurse: isHeadNurse=true → redirects to /nurses
 * - Nurse: default → redirects to /nurses
 * 
 * Use Cases:
 * - Creating new doctor accounts via stepper workflow
 * - Creating new nurse accounts (regular or head nurse)
 * - Multi-step provider registration process
 * 
 * @param {NewDoctorStepperFormProps} props - Component props
 * @param {boolean} props.isDoctor - Flag for doctor vs nurse
 * @param {boolean} props.isHeadNurse - Flag for head nurse vs regular nurse
 * @returns {React.ReactElement} The configured stepper form for provider creation
 */
const NewDynamicDoctorStepperForm = ({ isDoctor, isHeadNurse }: NewDoctorStepperFormProps) => {
  const doctor: ProviderInterface = getNewDoctorDataContent();
  const DoctorStepperForm = NewStepperForm<ProviderInterface>;

  const formType = isDoctor ? UserRolesEnum.DOCTOR : (isHeadNurse ? UserRolesEnum.HEAD_NURSE : UserRolesEnum.NURSE);
  const redirectPath = isDoctor ? RoutesConstants.DOCTORS : RoutesConstants.NURSES;

  return (
    <DoctorStepperForm 
      model={doctor} 
      redirect={redirectPath} 
      type={formType} 
      isDoctor={isDoctor}
    />
  );
};

export default NewDynamicDoctorStepperForm;